import CTNButton from '@ctn/ui/components/ctn-button';
import CTNCalendar from '@ctn/ui/components/ctn-calendar';
import CTNInput from '@ctn/ui/components/ctn-input';
import { useEffect } from 'react';
import { useForm, useFormContext } from 'react-hook-form';

import { useGlobalContext } from '@/context/global.context';
import { useSolicitudContext } from '@/context/solicitud.context';

import { STEP_ID } from '@/constants/tramite.constants';
import { commonCalendar } from '@/helpers/calendar';
import { type DataSolicitud } from '@/interfaces/context/ISolicitud.context.interface';
import { type FormValues } from '@/interfaces/model/don.interface';

type ConfirmacionEnvioSummaryProps = {
	readonly title: string;
	readonly isEditable?: boolean;
};

const ConfirmacionEnvioSummary = ({ title, isEditable }: ConfirmacionEnvioSummaryProps) => {
	const { control: controlGlobal } = useFormContext<Pick<FormValues, 'numeroTramite' | 'fechaVencimiento'>>();
	const { setActiveStep } = useSolicitudContext();
	const {
		maestrosTramite: { configuracionTramite },
	} = useGlobalContext();
	const { data } = useSolicitudContext();
	const { control, reset } = useForm<DataSolicitud>();

	const hasFechaVencimiento = configuracionTramite?.permiteVencimiento;

	useEffect(() => {
		if (data) {
			reset(data);
		}
	}, [data]);

	return (
		<form>
			<div className="o-splitter">
				<h4 className="c-pnp-heading-h4">{title}</h4>
				{isEditable && (
					<CTNButton
						mode="secondary"
						label="Modificar"
						variant="ghost"
						size="size-40"
						onClick={() => setActiveStep(STEP_ID.DOCUMENTACION)}
					/>
				)}
			</div>
			<div className="[ o-grid ] [ u-mt-16 ]">
				<div className="o-grid__row">
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="numeroTramite"
						label="Nº de solicitud"
						control={controlGlobal}
						maxLength={32}
					/>
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="tipoTramite.descripcion"
						label="Tipo de negocio jurídico"
						control={control}
						maxLength={32}
					/>
					{hasFechaVencimiento && (
						<CTNCalendar
							{...commonCalendar}
							noFeedBack
							displayOnly
							condensed
							monthsShown={1}
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="fechaVencimiento"
							label="Vigencia"
							todayButton=""
							appendTo={undefined}
							control={controlGlobal}
						/>
					)}
				</div>
			</div>
		</form>
	);
};

export default ConfirmacionEnvioSummary;
